<template>
  <!-- payment-dialog -->
  <v-dialog v-model="newPaymentDialog" width="700" persistent>
    <v-card class="shop-dialog">
      <v-card-title class="white">
        <v-row>
          <v-col cols="10">
            <h4 class="c-grey mb-0">افزودن پرداخت جدید</h4>
          </v-col>
          <v-col class="text-left pt-2">
            <span class="pointer" @click="closeDialog()"
              ><v-icon class="close-icon">$Close</v-icon></span
            >
          </v-col>
        </v-row>
      </v-card-title>
      <hr class="mt-2 mb-8" />
      <v-card-text class="custom-input">
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-if="userId"
              outlined
              dense
              label="نام مشتری"
              v-model="userName"
              disabled
              hide-details
            ></v-text-field>
            <v-autocomplete
              v-else
              @change="getBalance(newPayment.shopCustomerId)"
              auto-select-first
              no-data-text="نتیجه‌ای یافت نشد!"
              v-model="newPayment.shopCustomerId"
              :items="customers"
              item-text="name"
              item-value="id"
              label="نام مشتری"
              :loading="gettingCustomers"
              :disabled="gettingCustomers"
              dense
              outlined
              hide-details
              attach
              :menu-props="{ bottom: true, offsetY: true }"
              class="shop-select"
            >
              <template v-slot:append>
                <v-icon>$ArrowDown</v-icon>
              </template>
              <template slot="item" slot-scope="data">
                <!-- HTML that describe how select should render items when the select is open -->
                <!--<img
              v-if="data.item.royaltyTier"
              :src="computedIcon(data.item)"
              style="height: 26px; width: 26px"
              class="me-1"-->
                {{ data.item.name }}
              </template>
              <template slot="selection" slot-scope="data">
                <!-- HTML that describe how select should render items when the select is open -->
                <!--<img
              v-if="data.item.royaltyTier"
              :src="computedIcon(data.item)"
              style="height: 26px; width: 26px"
              class="me-1"
            />-->
                {{ data.item.name }}
              </template>
            </v-autocomplete>
            <div
              v-if="(newPayment.shopCustomerId || userId) && !gettingBalance"
              class="customer-info grey--text text--darken-2 mt-5"
            >
              <v-row>
                <v-col class="d-flex">
                  <h5 class="purple-color font-weight-bold me-1">
                    مانده حساب:
                  </h5>
                  <span v-if="customerBalanceData" class="ms-2">{{
                    customerBalanceData
                  }}</span>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col cols="12">
            <v-select
              v-model="newPayment.type"
              dense
              outlined
              hide-details
              label="نوع پرداخت"
              :items="paymentTypes"
              attach
              :menu-props="{ bottom: true, offsetY: true }"
              class="shop-select"
            >
              <template v-slot:append>
                <v-icon>$ArrowDown</v-icon>
              </template>
            </v-select></v-col
          >
        </v-row>
        <v-row>
          <v-col v-if="newPayment.type == 'cheque'" cols="12">
            <div
              class="pa-5 pt-10 my-2"
              style="
                border: 1px solid #ccc;
                border-radius: 15px;
                position: relative;
              "
            >
              <p
                class="px-4 c-grey"
                style="position: absolute; top: -9px; background-color: #fff"
              >
                اطلاعات چک را وارد کنید:
              </p>
              <v-row>
                <v-col class="py-0" sm="6" cols="12">
                  <v-text-field
                    type="number"
                    label="شماره چک"
                    v-model="cheque.number"
                    outlined
                    dense
                    class="mb-1"
                  ></v-text-field>
                </v-col>

                <v-col class="py-0" sm="6" cols="12">
                  <v-text-field
                    label="نام بانک"
                    v-model="cheque.bankName"
                    outlined
                    dense
                    class="mb-1"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="custom-input">
                <v-col class="py-0" sm="6" cols="12">
                  <v-text-field
                    type="number"
                    label="شماره صیاد"
                    v-model="cheque.chequeSayyad"
                    outlined
                    dense
                    class="mb-1"
                  ></v-text-field>
                  <v-select
                    v-model="cheque.chequeStatus"
                    dense
                    outlined
                    hide-details
                    label="وضعیت چک"
                    :items="chequeStatuses"
                    class="mb-1"
                  >
                    <template v-slot:append>
                      <v-icon>$ArrowDown</v-icon>
                    </template>
                  </v-select>
                </v-col>
                <v-col class="pt-0" sm="6" cols="12">
                  <span id="chequeDate">
                    <v-text-field
                      outlined
                      dense
                      type="text"
                      append-icon="mdi-calendar-edit"
                      v-model="cheque.date"
                      label="تاریخ چک"
                      :editable="true"
                      class="date-input mb-1"
                    >
                    </v-text-field>
                  </span>

                  <date-picker
                    v-model="cheque.date"
                    element="chequeDate"
                    color="#9c7fb7"
                  />
                </v-col>
                <v-col class="pt-0"> </v-col>
              </v-row>
              <div v-if="computedChequeInfo" class="d-flex flex-row">
                <v-icon class="red--text me-1">mdi-alert-circle-outline</v-icon>
                <span class="red--text"
                  >وارد کردن شماره چک، نام بانک و تاریخ چک الزامی است.</span
                >
              </div>
            </div>
          </v-col>
          <v-col v-if="newPayment.type == 'cardTransfer'" cols="12">
            <div
              class="pa-5 pt-10 my-2"
              style="
                border: 1px solid #ccc;
                border-radius: 15px;
                position: relative;
              "
            >
              <p
                class="px-4 c-grey"
                style="position: absolute; top: -9px; background-color: #fff"
              >
                اطلاعات کارت‌ها
              </p>
              <v-row class="custom-input">
                <v-col class="py-0" sm="6" cols="12">
                  <v-text-field
                    label="شماره کارت فرستنده"
                    v-model="buyerCardNumber"
                    outlined
                    dense
                    class="mb-1"
                    type="number"
                    data-maxlength="16"
                    oninput="this.value=this.value.slice(0,this.dataset.maxlength)"
                  ></v-text-field>
                  <getBankNameFromCardNumber
                    :digits="buyerCardNumber"
                    v-slot="{ bankName }"
                  >
                    <h6 v-if="bankName" class="me-10">
                      نام بانک: {{ bankName }}
                    </h6></getBankNameFromCardNumber
                  >
                </v-col>

                <v-col class="py-0" sm="6" cols="12">
                  <v-text-field
                    label="شماره کارت گیرنده"
                    v-model="recipientCardNumber"
                    outlined
                    dense
                    class="mb-1"
                    type="number"
                    data-maxlength="16"
                    oninput="this.value=this.value.slice(0,this.dataset.maxlength)"
                  ></v-text-field>
                  <getBankNameFromCardNumber
                    :digits="recipientCardNumber"
                    v-slot="{ bankName }"
                  >
                    <h6 v-if="bankName" class="me-10">
                      نام بانک: {{ bankName }}
                    </h6></getBankNameFromCardNumber
                  >
                </v-col>
              </v-row>

              <div v-if="computedCardInfo" class="d-flex flex-row mt-4">
                <v-icon class="red--text me-1">mdi-alert-circle-outline</v-icon>
                <span class="red--text"
                  >وارد کردن شماره کارت فرستنده و گیرنده الزامی است.</span
                >
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <vuetify-money
              label="مبلغ (ریال)"
              v-model="newPayment.amount"
              :valueWhenIsEmpty="whenIsEmpty"
              :options="vMoneyOptions"
              hide-details
              type="number"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12">
            <span id="date">
              <v-text-field
                outlined
                dense
                type="text"
                append-icon="mdi-calendar-edit"
                v-model="newPayment.date"
                label="تاریخ"
                :editable="true"
                hide-details
              >
              </v-text-field>
            </span>

            <date-picker
              v-model="newPayment.date"
              element="date"
              color="#9c7fb7"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <span id="time">
              <v-text-field
                outlined
                dense
                type="text"
                append-icon="mdi-clock-time-two-outline"
                v-model="newPayment.time"
                label="ساعت"
                class="date-input"
                hide-details
              >
              </v-text-field>
            </span>

            <date-picker
              v-model="newPayment.time"
              type="time"
              element="time"
              color="#9c7fb7"
            ></date-picker>
          </v-col>
          <v-col cols="12">
            <v-textarea
              placeholder="توضیحات"
              outlined
              dense
              hide-details
              v-model="newPayment.description"
            ></v-textarea
          ></v-col>
        </v-row>
        <div class="text-left pt-7 pb-5">
          <v-btn
            :disabled="computedBtn"
            @click="addNewPayment()"
            :loading="loading"
            class="purple-mainBtn"
            width="90"
            >ثبت</v-btn
          >
          <v-btn class="red-borderedBtn ms-2" width="90" @click="closeDialog()"
            >بازگشت</v-btn
          >
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Axios from "axios";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { getBankNameFromCardNumber } from "@persian-tools/vue-persian-tools/dist/modules";
import moment from "moment-jalaali";
// import VueBarcode from "vue-barcode";
import prices from "../mixins/prices";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    // barcode: VueBarcode,
    getBankNameFromCardNumber,
  },
  props: ["dialog", "userId", "userName"],
  mixins: [prices],
  data: function () {
    return {
      reactivity: false,
      isLoaded: false,
      info: [],
      loading: false,
      guide: false,
      types: ["همه", "پرداخت شده", "برگشت خورده"],
      moment: moment,
      gettingReceipt: false,
      startDate: moment(new Date()).subtract(7, "days").format("jYYYY/jMM/jDD"),
      endDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      excelFields: [
        { field: "shopCustomerName", label: "نام مشتری" },
        { field: "incomeId", label: "کد پرداخت" },
        { field: "amount", label: "مبلغ پرداخت شده(ریال)" },
        { field: "type", label: "نوع پرداخت" },
        { field: "status", label: "وضعیت" },
        { field: "description", label: "توضیحات" },
        { field: "date", label: "تاریخ" },
        { field: "time", label: "زمان" },
      ],
      TotalRows: "",
      codeFilter: "",
      nameFilter: "",
      typeFilter: "همه",
      customers: [],
      customerName: "",
      customerPriority: "",
      customerMobile: "",
      customerEmail: "",
      userInput: "",
      currentPage: 1,
      perPage: 10,
      perPageOptions: [4, 10, 20],
      T: 1,
      striped: true,
      selectedCustomer: {},
      isBusy: true,
      busy: false,
      filter: null,
      selected: "",
      progress: false,
      customer: {},
      printInvoice: {},
      returnModal: false,
      paymentType: "",
      newPaymentDialog: true,
      paymentTypes: [
        { value: "cash", text: "نقدی" },
        { value: "card", text: "کارتخوان" },
        { value: "cheque", text: "چک" },
        { value: "cardTransfer", text: "کارت به کارت" },
      ],
      chequeStatuses: [
        { value: "passed", text: "پاس شده" },
        { value: "returned", text: "برگشت خورده" },
        { value: "submitted", text: "ثبت شده" },
      ],
      testData: [],
      editPaymentDialog: false,
      detailsDialog: false,
      payment: {},
      customers: [],
      gettingCustomers: false,
      newPayment: {
        customerBalance: "",
        newPaymentBalance: "",
        amount: "",
      },
      cheque: {},
      customerBalanceData: "",
      gettingBalance: false,
      editData: {},
      selectedId: "",
      recipientCardNumber: "",
      buyerCardNumber: "",
      addLoading: false,
    };
  },

  methods: {
    computedIcon(item) {
      if (item.royaltyTier == "coper") {
        return "/icons8-star-35(1).png";
      } else if (item.royaltyTier == "silver") {
        return "/icons8-star-35.png";
      } else if (item.royaltyTier == "gold") {
        return "/icons8-star-35(2).png";
      } else if (item.royaltyTier == "diamond") {
        return "/icons8-diamond-35.png";
      }
    },
    addNewPayment() {
      this.loading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/payments/addfund",
        {
          chequeNo:
            this.newPayment.type == "cheque"
              ? this.cheque.number
                ? this.cheque.number
                : ""
              : undefined,
          chequeDate:
            this.newPayment.type == "cheque"
              ? this.cheque.date
                ? this.cheque.date
                : ""
              : undefined,
          chequeSayyad:
            this.newPayment.type == "cheque"
              ? this.cheque.chequeSayyad
                ? this.cheque.chequeSayyad
                : ""
              : undefined,
          chequeBank:
            this.newPayment.type == "cheque"
              ? this.cheque.bankName
                ? this.cheque.bankName
                : ""
              : undefined,
          paymentType: this.newPayment.type,
          shopCustomerId: this.userId
            ? this.userId
            : this.newPayment.shopCustomerId,
          amount: Number(this.newPayment.amount),
          description: this.newPayment.description,
          date: this.newPayment.date + " " + this.newPayment.time,
          buyerCardNumber:
            this.newPayment.type == "cardTransfer"
              ? Number(this.buyerCardNumber)
              : undefined,
          recipientCardNumber:
            this.newPayment.type == "cardTransfer"
              ? Number(this.recipientCardNumber)
              : undefined,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.loading = false;
          if (res.status == 201) {
            this.toast(res.data.message, "success");
            this.newPayment = {};
            this.newPaymentDialog = false;
            this.$emit("submitPayment");
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.loading = false;
        });
    },
    closeDialog() {
      this.newPaymentDialog = false;
      this.$emit("closeDialog");
    },
    getBalance(customerId) {
      this.purchaseDone = false;
      this.gettingBalance = true;
      this.customerBalanceData = "";
      Axios.post(
        this.baseUrl + "/ppkpms/shop/payments/customerBalance",
        {
          shopCustomerId: customerId,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.allShopIncomeBalance = res.data.allShopIncomeBalance;
            this.customerBalanceData = res.data.balanceData;
            if (this.customerBalanceData > 0) {
              this.customerBalanceData =
                this.customerBalanceData.toLocaleString() + " ریال بدهکار";
            } else if (this.customerBalanceData < 0) {
              this.customerBalanceData =
                Math.abs(this.customerBalanceData).toLocaleString() +
                " ریال بستانکار";
            } else {
              this.customerBalanceData = "تسویه";
            }
            setTimeout(() => {
              this.gettingBalance = false;
            }, 500);
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    getCustomers() {
      this.gettingCustomers = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customers/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.gettingCustomers = false;
          if (res.status == 200) {
            this.customers = res.data;
            if (this.tempCustomer) {
              this.newPayment.shopCustomerId = this.tempCustomer;
              this.getBalance(this.tempCustomer);
            }
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.gettingCustomers = false;
          this.toast(err.response.data, "error");
        });
    },
  },
  computed: {
    computedChequeInfo() {
      if (this.newPayment.type == "cheque") {
        if (
          !this.cheque.number ||
          !this.cheque.bankName ||
          !this.cheque.date ||
          !this.cheque.chequeStatus
        ) {
          return true;
        } else return false;
      } else return false;
    },
    computedCardInfo() {
      if (this.newPayment.type == "cardTransfer") {
        if (!this.recipientCardNumber || !this.buyerCardNumber) {
          return true;
        } else return false;
      } else return false;
    },
    computedBtn() {
      if (this.newPayment.type && this.newPayment.amount) {
        if (this.newPayment.type == "cardTransfer") {
          if (!this.recipientCardNumber || !this.buyerCardNumber) {
            return true;
          } else return false;
        } else if (this.newPayment.type == "cheque") {
          if (
            !this.cheque.number ||
            !this.cheque.bankName ||
            !this.cheque.date
          ) {
            return true;
          } else return false;
        } else return false;
      } else return true;
    },
  },

  mounted() {
    if (!this.userId) {
      this.getCustomers();
    } else {
      this.getBalance(this.userId);
    }
    this.newPaymentDialog = this.dialog;
  },
};
</script>

<style lang="scss">
.v-dialog {
  overflow-y: hidden !important;
}
</style>
